/**
 * Manages Indicators - Handles all indicator operations outside of React lifecycle
 */

import { handleFloorExpand } from './StackedImageManager'

const HandleIndicator = () => {
  const indicators = document.querySelectorAll('.js-indicator')

  if (indicators.length) {
    // Handle placement.
    placeIndicators()

    // Handle clicks.
    indicators.forEach(indicator => {
      indicator.addEventListener("click", () => {
        const floorID = indicator.dataset.indicatorId

        handleFloorExpand(floorID)

        activateIndicator(indicator)
      })
    })
  }
}

export const activateIndicatorFromFloor = ( floorID ) => {
  const indicators = document.querySelectorAll('.js-indicator')

  if (indicators.length) {
    indicators.forEach(indicator => {
      const indicatorID = indicator.dataset.indicatorId

      if (floorID === indicatorID) {
        activateIndicator(indicator)
      }
    })
  }
}

const activateIndicator = ( indicator ) => {
  disableAllIndicators()

  indicator.classList.add('is-active')
  indicator.dataset.active = true
}

const disableAllIndicators = () => {
  const indicators = document.querySelectorAll('.js-indicator')

  if (indicators.length) {
    indicators.forEach(indicator => {
      indicator.classList.remove('is-active')
      indicator.dataset.active = false
    })
  }
}

const placeIndicators = () => {
  const indicatorLists = document.querySelectorAll('.js-indicator-list')

  if (indicatorLists.length) {
    indicatorLists.forEach(list => {
      list.style.top = `calc(50% - ${ list.clientHeight / 2 }px)`
    })
  }
}

export default HandleIndicator;
